/**
 * Plausible Analytics wrapper — privacy-friendly, no cookies, GDPR-compliant.
 *
 * Config via env:
 *   REACT_APP_PLAUSIBLE_DOMAIN=colucciassicuratori.com  (dominio Plausible)
 *   REACT_APP_PLAUSIBLE_SRC=https://plausible.io/js/script.js  (opzionale, default plausible.io)
 *
 * Se REACT_APP_PLAUSIBLE_DOMAIN è vuoto → dev/log-only mode (console).
 * Nessun cookie viene creato. Nessuna richiesta di consenso necessaria.
 */

const DOMAIN = process.env.REACT_APP_PLAUSIBLE_DOMAIN || "";
const SCRIPT_SRC = process.env.REACT_APP_PLAUSIBLE_SRC ||
  "https://plausible.io/js/script.tagged-events.js";

let injected = false;

/** Inietta lo script Plausible nel <head>. Idempotente. No-op se DOMAIN vuoto. */
export function initPlausible() {
  if (injected) return;
  if (!DOMAIN) {
    // eslint-disable-next-line no-console
    console.info("[analytics] Plausible disabled (REACT_APP_PLAUSIBLE_DOMAIN empty). Events log-only.");
    injected = true;
    return;
  }
  const s = document.createElement("script");
  s.setAttribute("defer", "true");
  s.setAttribute("data-domain", DOMAIN);
  s.src = SCRIPT_SRC;
  document.head.appendChild(s);
  // Shim: se plausible non è ancora caricato, accoda gli eventi
  window.plausible = window.plausible || function () {
    (window.plausible.q = window.plausible.q || []).push(arguments);
  };
  injected = true;
}

/**
 * Emette un evento custom Plausible.
 * In dev/no-DOMAIN mode → console.log.
 * @param {string} name — es. "Wizard_Step_View"
 * @param {object} props — es. { ramo: "casa", step: 3 }
 */
export function trackEvent(name, props = {}) {
  const cleanProps = Object.fromEntries(
    Object.entries(props).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );
  if (!DOMAIN) {
    // eslint-disable-next-line no-console
    console.log("[analytics][dev]", name, cleanProps);
    return;
  }
  try {
    if (typeof window.plausible === "function") {
      window.plausible(name, { props: cleanProps });
    }
  } catch {
    /* fail-silent */
  }
}

/* ==== Eventi standardizzati ==== */

/** Cambio step di un wizard. Chiamare quando lo step diventa visibile. */
export function trackWizardStep({ ramo, step_number, step_name, partner_id }) {
  trackEvent("Wizard_Step_View", { ramo, step_number, step_name, partner_id });
}

/** Submit wizard successo. */
export function trackWizardSubmit({ ramo, partner_id }) {
  trackEvent("Wizard_Submit_Success", { ramo, partner_id });
}

/** Download PDF (client-side dal drawer). */
export function trackPdfDownloadClient({ ramo, tipo }) {
  trackEvent("PDF_Download_Client", { ramo, tipo });
}

/** Download PDF admin. */
export function trackPdfDownloadAdmin({ ramo, tipo }) {
  trackEvent("PDF_Download_Admin", { ramo, tipo });
}

/** Auto-creazione account cliente K2 (opt-in submit). */
export function trackAccountCreated({ ramo }) {
  trackEvent("Account_Created", { ramo });
}
